import { z } from 'zod';
import { NOTIFICACAO_CANAIS, NOTIFICACAO_STATUSES } from '../enums.js';
export const ListarNotificacoesQuerySchema = z.object({
    canal: z.enum(NOTIFICACAO_CANAIS).optional(),
    status: z.enum(NOTIFICACAO_STATUSES).optional(),
    funcionarioId: z.string().min(1).optional(),
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(200).default(50),
});
// Reenvio manual de comprovante de um registro de ponto.
export const EnviarComprovanteSchema = z.object({
    registroId: z.string().min(1),
});
//# sourceMappingURL=notificacao.js.map